.root {
  width: 100%;
  min-width: 0;
}
.root[data-compact] {
  position: relative;
  min-height: calc(var(--space-16) * 3);
}
:global([inert]) .root {
  visibility: hidden;
}
